import { Attachments, Button, Column, Field, Form, Loader, ManyToManySelect, Select, Table } from '@smartplatform/ui';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Title } from 'root/admin/components';
import { Editor } from '../../components';
import store from '../../store';

@withRouter
@observer
export default class DispatchEdit extends React.Component {
	@observable record;
	@observable recipients;

	constructor(props) {
		super(props);
		this.init();
	}

	@action init = async () => {
		this.id = this.props.match.params.id;
		if (isNaN(this.id)) {
			this.record = new store.model.Dispatch();
		} else {
			this.record = await store.model.Dispatch.findById(this.id, {
				include: [
					{
						relation: 'recipients',
						scope: {
							include: [{ relation: 'deputy' }, { relation: 'depConv' }],
						},
					},
					{ relation: 'deputies' },
					{ relation: 'attachments' },
				],
			});
			this.recipients = await this.record.recipients();
		}
	};

	prepareRecipients = async () => {
		await store.model.Dispatch.prepareRecipients(+this.record.id);
		this.init();
	};

	sendToRecipients = async () => {
		await store.model.Dispatch.sendToRecipients(+this.record.id);
		this.init();
	};

	onSave = async record => {
		const { path } = this.props;
		isNaN(this.id) && store.history.push(`${path}/${record.id}`);
		return true;
	};

	onDelete = () => {
		const { path } = this.props;
		store.history.push(path);
	};

	sendButtons = (
		<div style={{ marginTop: '1rem' }}>
			<Button label="Разосласть сообщение" style={{ marginRight: '1rem' }} className="btn-primary" onClick={this.sendToRecipients} />
			<Button
				label="Отмена"
				onClick={async () => {
					await this.record.recipients.destroy();
					this.init();
				}}
			/>
		</div>
	);

	controls = (
		<div style={{ marginTop: '1rem' }}>
			<Button className="btn-primary" label="Подготовить список" onClick={this.prepareRecipients} />
			<p>
				<small>* не забудте сохранить сообщение перед подготовкой списка</small>
			</p>
		</div>
	);

	render() {
		const fio = deputy => (deputy ? `${deputy.lastName} ${deputy.firstName} ${deputy.middleName}` : '');
		const fioShort = deputy =>
			deputy
				? `${deputy.lastName} ${deputy.firstName && deputy.firstName.substr(0, 1)}. ${deputy.middleName && deputy.middleName.substr(0, 1)}.`
				: '';

		if (!this.record) {
			return <Loader />;
		}

		return (
			<div>
				<Title record={this.record} name="Сообщение депутатам" />
				<Form
					record={this.record}
					rootPath={this.props.rootPath}
					writeAllowed={this.recipients && !this.recipients.totalCount > 0}
					onSave={this.onSave}
					onDelete={this.onDelete}
					stay
					controls={!this.record.sended && this.record.id && this.recipients && this.recipients.totalCount === 0 && this.controls}
				>
					<Field property="name" label="Заголовок" />
					<div className="article__edit-content">
						<h5>Содержание</h5>
						<Editor value={this.record.text} onChange={text => (this.record.text = text)} height={300} />
					</div>
					<div style={{ margin: '1rem 0' }}>
						{this.record.id && !this.record.sended ? (
							<Attachments record={this.record} store={store.model} />
						) : !this.record.id ? (
							<h5>Создайте сообщение, чтобы прикрепить файлы и добавить адресатов </h5>
						) : (
							<>
								<h3>Приложения:</h3>
								{this.record.attachments().map(a => (
									<em key={`attachment-${a.id}`}>{a.filename}</em>
								))}
							</>
						)}
					</div>
					{!this.record.sended && this.record.id && this.record && this.recipients && this.recipients.totalCount === 0 && (
						<>
							<h5> Адресаты </h5>
							<div>
								<Field property="sendAll" label="Отправить всем депутатам" />
								{!this.record.sendAll && (
									<>
										<Field label="Депутаты">
											<ManyToManySelect
												relation="deputies"
												computed={fio}
												itemTag={fioShort}
												searchFields={[{ name: 'lastName', start: true }]}
											/>
										</Field>
										<Field label="Фракции">
											<ManyToManySelect
												relation="fractions"
												property="shortName"
												itemTag={f => f.shortName}
												filter={{ where: { existing: true } }}
												noSearch={true}
											/>
										</Field>
										<Field label="Комитеты">
											<ManyToManySelect relation="committees" property="name" itemTag={f => f.name} noSearch={true} />
										</Field>
									</>
								)}
								<div className="form-field ">
									<label>Уведомление</label>
									<Select
										className="drop-down-md"
										items={[
											{ value: '', label: 'Без уведомления' },
											{ value: 'all', label: 'СМС и Email' },
											{ value: 'sms', label: 'CМС' },
											{ value: 'email', label: 'Email' },
										]}
										value={this.record.sendMethod}
										onChange={v => {
											this.record.sendMethod = v;
										}}
										isRequired={true}
										noSearch={true}
									/>
								</div>
							</div>
						</>
					)}
					{this.recipients && this.recipients.length > 0 && (
						<div>
							{this.record.sended ? (
								<h3> Сообщение разослано следующим депутатам </h3>
							) : (
								<h3>Депутаты которым будет разослано сообщение </h3>
							)}
							<Table records={this.record.recipients().filter(recipient => !recipient.depConv?.endDate)}>
								<Column label="ФИО депутата" relation="deputy" computed={fio} />
								<Column label="Email" property="email" />
								<Column label="Телефон" relation="deputy" property="phone" />
								{this.record.sended && <Column label="Сообщение прочитано" property="checked" />}
							</Table>
							<h3 style={{ marginTop: '1rem' }}>Метод уведомления:</h3>
							<p>
								{this.record.sendMethod === 'all'
									? 'СМС и Email'
									: this.record.sendMethod === 'sms'
									? 'CMC'
									: this.record.sendMethod === 'email'
									? 'Email'
									: 'Без оповещения'}
							</p>
							{!this.record.sended && this.sendButtons}
						</div>
					)}
				</Form>
			</div>
		);
	}
}
